/**
 * Password reset flow constants
 */

/** Minimum interval (ms) between password-reset email requests for the same address. */
export const PASSWORD_RESET_COOLDOWN_MS = 60_000

export const PASSWORD_RESET_COOLDOWN_MESSAGE =
  'A password reset email was already sent. Please wait before requesting another one.'
